var $cc69b10c8d715d87$exports = {};
$cc69b10c8d715d87$exports = {
    "collapse": `Restr\xe2nge\u{21B}i`,
    "expand": `Extinde\u{21B}i`
};


export {$cc69b10c8d715d87$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
